module.exports = __webpack_public_path__ + "static/media/bg.457b6203.png";